module.exports = __webpack_public_path__ + "static/media/milestone_02.ae62cd89.png";